var START_OF_ISO_WEEK = 1;
var resetYear = function (d) {
    if (d === null)
        return null;
    return new Date(d.getFullYear(), 0);
};
var resetISOWeek = function (d) {
    if (d === null)
        return null;
    var day = d.getDay();
    var diff = (day < START_OF_ISO_WEEK ? 7 : 0) + day - START_OF_ISO_WEEK;
    return new Date(d.getFullYear(), d.getMonth(), d.getDate() - diff);
};
function asValidDateOrNull(date) {
    if (isValidDate(date))
        return date;
    return null;
}
function asValidDateOrThrow(date, origin) {
    if (isValidDate(date))
        return date;
    throw new TypeError("Cant parse date from \"" + origin + "\"");
}
var newValidDateOrThrow = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var result = new ((_a = Date).bind.apply(_a, [void 0].concat(args)))();
    return asValidDateOrThrow(result, args);
    var _a;
};
function isValidDate(d) {
    return d !== null && d instanceof Date && isFinite(d.getTime());
}
function leadZero(n, targetLength) {
    if (targetLength === void 0) {
        targetLength = 2;
    }
    var output = n + '';
    while (output.length < targetLength) {
        output = '0' + output;
    }
    return output;
}
function absFloor(num) {
    if (num < 0) {
        // -0 -> 0
        return Math.ceil(num) || 0;
    }
    else {
        return Math.floor(num);
    }
}
function tokensRx(obj) {
    var keys = [];
    for (var key in obj) {
        keys.push(key);
    }
    keys.sort(function (a, b) { return b.length - a.length; });
    return new RegExp(keys.join('|') + '|\\[[^[]*\\]|.', 'g');
}
var diffCalendarDate = function (d1, d2) {
    if (!isValidDate(d1) || !isValidDate(d2))
        return null;
    var u1 = Date.UTC(d1.getFullYear(), d1.getMonth(), d1.getDate());
    var u2 = Date.UTC(d2.getFullYear(), d2.getMonth(), d2.getDate());
    return absFloor((u1 - u2) / 86400000 /* Date */);
};
/**
 * Makes function that return part of ISO 8610 formatted string
 */
function createFormatIso(len) {
    return function (d) {
        if (!isValidDate(d))
            return null;
        var date = new Date(d.getTime());
        date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
        return date.toISOString().substring(0, len);
    };
}
// YYYY-MM-DD
// YYYY-MM-DDTHH:mm
// YYYY-MM-DDTHH:mm:ss.SSS
var formatLocalIso = createFormatIso(23);
var formatters = {
    // Month: 1, 2, ..., 12
    'M': function (date) { return date.getMonth() + 1; },
    // Month: 01, 02, ..., 12
    'MM': function (date) { return leadZero(date.getMonth() + 1); },
    // Quarter: 1, 2, 3, 4
    'Q': function (date) { return Math.ceil((date.getMonth() + 1) / 3); },
    // Day of month: 1, 2, ..., 31
    'D': function (date) { return date.getDate(); },
    // Day of month: 01, 02, ..., 31
    'DD': function (date) { return leadZero(date.getDate()); },
    // Day of year: 1, 2, ..., 366
    'DDD': function (date) { return diffCalendarDate(date, resetYear(date)) + 1; },
    // Day of year: 001, 002, ..., 366
    'DDDD': function (date) { return leadZero(formatters['DDD'](date), 3); },
    // Day of week: 0, 1, ..., 6
    'd': function (date) { return date.getDay(); },
    // Day of ISO week: 1, 2, ..., 7
    'E': function (date) { return date.getDay() || 7; },
    // ISO week: 1, 2, ..., 53
    'W': function (date) {
        var isoYear = +formatters['GGGG'](date);
        var start = resetISOWeek(newValidDateOrThrow(isoYear, 0, 4));
        return Math.floor(diffCalendarDate(date, start) / 7) + 1;
    },
    // ISO week: 01, 02, ..., 53
    'WW': function (date) { return leadZero(formatters['W'](date)); },
    // Year: 00, 01, ..., 99
    'YY': function (date) { return date.getFullYear().toString().slice(-2); },
    // Year: 1900, 1901, ..., 2099
    'YYYY': function (date) { return leadZero(date.getFullYear(), 4); },
    // ISO week-numbering year: 00, 01, ..., 99
    'GG': function (date) { return formatters['GGGG'](date).toString().slice(-2); },
    // ISO week-numbering year: 1900, 1901, ..., 2099
    'GGGG': function (date) {
        var startYear = date.getFullYear();
        var correction = date < resetISOWeek(newValidDateOrThrow(startYear, 0, 4))
            ? -1
            : date < resetISOWeek(newValidDateOrThrow(startYear + 1, 0, 4))
                ? 0
                : 1;
        return leadZero(startYear + correction, 4);
    },
    // Hour: 0, 1, ... 23
    'H': function (date) { return date.getHours(); },
    // Hour: 00, 01, ..., 23
    'HH': function (date) { return leadZero(date.getHours()); },
    // Hour: 1, 2, ..., 12
    'h': function (date) { return (date.getHours() % 12) || 12; },
    // Hour: 01, 02, ..., 12
    'hh': function (date) { return leadZero(formatters['h'](date)); },
    // Minute: 0, 1, ..., 59
    'm': function (date) { return date.getMinutes(); },
    // Minute: 00, 01, ..., 59
    'mm': function (date) { return leadZero(date.getMinutes()); },
    // Second: 0, 1, ..., 59
    's': function (date) { return date.getSeconds(); },
    // Second: 00, 01, ..., 59
    'ss': function (date) { return leadZero(date.getSeconds()); },
    // 1/10 of second: 0, 1, ..., 9
    'S': function (date) { return Math.floor(date.getMilliseconds() / 100); },
    // 1/100 of second: 00, 01, ..., 99
    'SS': function (date) { return leadZero(Math.floor(date.getMilliseconds() / 10)); },
    // Millisecond: 000, 001, ..., 999
    'SSS': function (date) { return leadZero(date.getMilliseconds(), 3); },
    // Timezone: -01:00, +00:00, ... +12:00
    'Z': function (date) { return formatTimezone(date.getTimezoneOffset(), ':'); },
    // Timezone: -0100, +0000, ... +1200
    'ZZ': function (date) { return formatTimezone(date.getTimezoneOffset()); },
    // Seconds timestamp: 512969520
    'X': function (date) { return Math.floor(date.getTime() / 1000); },
    // Milliseconds timestamp: 512969520900
    'x': function (date) { return date.getTime(); },
};
function formatTimezone(offset, delimeter) {
    if (delimeter === void 0) {
        delimeter = '';
    }
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    return sign + leadZero(hours) + delimeter + leadZero(minutes);
}
function splitToTokens(template, formatters) {
    var RX_TOKENS = tokensRx(formatters);
    var tokens = template.match(RX_TOKENS);
    // this regexp cant fail because of "|."
    var result = [];
    for (var i = 0; i < tokens.length; i++) {
        var token = tokens[i];
        var tokenFn = formatters[token];
        if (tokenFn) {
            result.push(tokenFn);
        }
        else if (token.charAt(0) === '[' && token.charAt(token.length - 1) === ']') {
            result.push(token.substring(1, token.length - 1));
        }
        else {
            result.push(token);
        }
    }
    return result;
}
function formatByTokens(d, tokens) {
    var result = [];
    for (var i = 0; i < tokens.length; i++) {
        var token = tokens[i];
        result.push(typeof token === 'function' ? token(d, i, tokens) : token);
    }
    return result.join('');
}
function createFormat(formatters) {
    var cache = {};
    return function (d, template) {
        if (!isValidDate(d))
            return null;
        var tokens = cache[template];
        if (tokens === undefined) {
            tokens = splitToTokens(template, formatters);
            cache[template] = tokens;
        }
        return formatByTokens(d, tokens);
    };
}
/**
 * format without any locale, just numbers
 */
var format = createFormat(formatters);
var rx1 = '\\d';
var rx2 = '\\d\\d';
var rx12 = '\\d\\d?';
var rx3 = '\\d{3}';
var rx4 = '\\d{4}';
var rxN = '\\d{5,}';
var defaultParsers = {
    // Month: 1, 2, ..., 12
    'M': [rx12, function (date, value) { date.setMonth(+value - 1); }],
    // Month: 01, 02, ..., 12
    'MM': [rx2, function (date, value) { date.setMonth(+value - 1); }],
    // Quarter: 1, 2, 3, 4
    // 'Q': (date, value) => Math.ceil((date.getMonth() + 1) / 3),
    // Day of month: 1, 2, ..., 31
    'D': [rx12, function (date, value) { date.setDate(+value); }],
    // Day of month: 01, 02, ..., 31
    'DD': [rx2, function (date, value) { date.setDate(+value); }],
    // Day of year: 1, 2, ..., 366
    // TODO 'DDD': (date, value) => getDayOfYear(date),
    // Day of year: 001, 002, ..., 366
    // TODO 'DDDD': (date, value) => leadZero(getDayOfYear(date), 3),
    // Day of week: 0, 1, ..., 6
    // 'd': (date, value) => date.getDay(),
    // Day of ISO week: 1, 2, ..., 7
    // 'E': (date, value) => date.getDay() || 7,
    // ISO week: 1, 2, ..., 53
    // TODO 'W': (date, value) => getISOWeek(date),
    // ISO week: 01, 02, ..., 53
    // TODO 'WW': (date, value) => leadZero(getISOWeek(date)),
    // Year: 00, 01, ..., 99
    'YY': [rx2, function (date, value) { date.setFullYear(2000 + +value); }],
    // Year: 1900, 1901, ..., 2099
    'YYYY': [rx4, function (date, value) { date.setFullYear(+value); }],
    // ISO week-numbering year: 00, 01, ..., 99
    // TODO 'GG': (date, value) => getISOYear(date).toString().slice(-2),
    // ISO week-numbering year: 1900, 1901, ..., 2099
    // TODO 'GGGG': (date, value) => getISOYear(date),
    // Hour: 0, 1, ... 23
    'H': [rx12, function (date, value) { date.setHours(+value); }],
    // Hour: 00, 01, ..., 23
    'HH': [rx2, function (date, value) { date.setHours(+value); }],
    // Hour: 1, 2, ..., 12
    //'h': (date, value) => (date.getHours() % 12) || 12,
    // Hour: 01, 02, ..., 12
    // 'hh': (date, value) => leadZero(formatters['h'](date)),
    // Minute: 0, 1, ..., 59
    'm': [rx12, function (date, value) { date.setMinutes(+value); }],
    // Minute: 00, 01, ..., 59
    'mm': [rx2, function (date, value) { date.setMinutes(+value); }],
    // Second: 0, 1, ..., 59
    's': [rx12, function (date, value) { date.setSeconds(+value); }],
    // Second: 00, 01, ..., 59
    'ss': [rx2, function (date, value) { date.setSeconds(+value); }],
    // 1/10 of second: 0, 1, ..., 9
    'S': [rx1, function (date, value) { date.setMilliseconds(+value * 100); }],
    // 1/100 of second: 00, 01, ..., 99
    'SS': [rx2, function (date, value) { date.setMilliseconds(+value * 10); }],
    // Millisecond: 000, 001, ..., 999
    'SSS': [rx3, function (date, value) { date.setMilliseconds(+value); }],
    // Timezone: -01:00, +00:00, ... +12:00
    // TODO 'Z': (date, value) => formatTimezone(date.getTimezoneOffset(), ':'),
    // Timezone: -0100, +0000, ... +1200
    // TODO 'ZZ': (date, value) => formatTimezone(date.getTimezoneOffset()),
    // Seconds timestamp: 512969520
    'X': [rxN, function (date, value) { date.setTime(+value * 1000); }],
    // Milliseconds timestamp: 512969520900
    'x': [rxN, function (date, value) { date.setTime(+value); }],
};
function escapeRegExp(text) {
    return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
}
function createParse(parsers) {
    var RX_TOKENS = tokensRx(parsers);
    return function parse(dateStr, template) {
        var tokens = template.match(RX_TOKENS);
        // this regexp cant fail because of "|."
        var parsersFn = [];
        var rxStr = tokens.map(function (token) {
            var parser = parsers[token];
            if (parser) {
                parsersFn.push(parser[1]);
                var regexpPart = parser[0];
                return "(" + regexpPart + ")";
            }
            if (token.charAt(0) === '[' && token.charAt(token.length - 1) === ']')
                token = token.substring(1, token.length - 1);
            return escapeRegExp(token);
        }).join('');
        var rx = new RegExp('^' + rxStr + '$', 'i');
        var values = dateStr.match(rx);
        if (!values)
            return null;
        /* NOTE second zero needed to set current timezone */
        var date = new Date(0, 0);
        values.slice(1).forEach(function (value, index) {
            var parserFn = parsersFn[index];
            parserFn(date, value);
        });
        return asValidDateOrNull(date);
    };
}
/**
 * parse without any locale, just numbers
 */
var parse = createParse(defaultParsers);
var OperatorType = {};
OperatorType.Eq = /** @type {?} */ ("eq");
OperatorType.Less = /** @type {?} */ ("lt");
OperatorType.Greater = /** @type {?} */ ("gt");
OperatorType.GreaterOrEqual = /** @type {?} */ ("ge");
OperatorType.LessOrEqual = /** @type {?} */ ("le");
OperatorType.NotEqual = /** @type {?} */ ("ne");
OperatorType[OperatorType.Eq] = "Eq";
OperatorType[OperatorType.Less] = "Less";
OperatorType[OperatorType.Greater] = "Greater";
OperatorType[OperatorType.GreaterOrEqual] = "GreaterOrEqual";
OperatorType[OperatorType.LessOrEqual] = "LessOrEqual";
OperatorType[OperatorType.NotEqual] = "NotEqual";
var OrderBy = {};
OrderBy.Asc = /** @type {?} */ ("asc");
OrderBy.Desc = /** @type {?} */ ("desc");
OrderBy[OrderBy.Asc] = "Asc";
OrderBy[OrderBy.Desc] = "Desc";
var Query = /** @class */ (function () {
    /**
     * @param {?=} extendedPropName
     */
    function Query(extendedPropName) {
        this._select = [];
        this._filter = [];
        this._orderBy = [];
        this._expand = [];
        this._extendedPropName = extendedPropName;
    }
    /**
     * @return {?}
     */
    Query.create = function () {
        return new Query();
    };
    /**
     * @param {?} value
     * @return {?}
     */
    Query.isGuid = function (value) {
        value = value.toLowerCase();
        var /** @type {?} */ regex = /[a-f0-9]{8}(?:-[a-f0-9]{4}){3}-[a-f0-9]{12}/i;
        var /** @type {?} */ match = regex.exec(value);
        return match != null;
    };
    /**
     * @param {?} field
     * @param {?} order
     * @return {?}
     */
    Query.prototype.orderBy = function (field, order) {
        if (!field || field.length == 0)
            return this;
        return this.orderByComplex(field + " " + order);
    };
    /**
     * @param {?} orderBy
     * @return {?}
     */
    Query.prototype.orderByComplex = function (orderBy) {
        this._orderBy.push(orderBy);
        return this;
    };
    /**
     * @param {?} propertyName
     * @param {?=} func
     * @return {?}
     */
    Query.prototype.expand = function (propertyName, func) {
        var /** @type {?} */ exQuery = new Query(propertyName);
        if (func != null) {
            func(exQuery);
        }
        this._expand.push(exQuery);
        return this;
    };
    /**
     * @param {?} field
     * @param {?} operator
     * @param {?} val2
     * @param {?=} format
     * @return {?}
     */
    Query.prototype.filter = function (field, operator, val2, format$$1) {
        if ((field == null || field.length == 0) || (val2 == null || val2.length == 0))
            return this;
        if (val2 instanceof Date) {
            if (format$$1)
                val2 = format(val2, format$$1);
            else
                val2 = formatLocalIso(val2) + "Z";
        }
        else if (typeof val2 == "string" && !Query.isGuid(val2) && val2.indexOf("'") === -1) {
            val2 = "'" + val2 + "'";
        }
        return this.filterComplex(field + " " + operator.toString() + " " + val2);
    };
    /**
     * @param {?} filter
     * @return {?}
     */
    Query.prototype.filterComplex = function (filter) {
        this._filter.push(filter);
        return this;
    };
    /**
     * @param {?} skip
     * @return {?}
     */
    Query.prototype.skip = function (skip) {
        this._skip = skip;
        return this;
    };
    /**
     * @param {?} top
     * @return {?}
     */
    Query.prototype.top = function (top) {
        this._top = top;
        return this;
    };
    /**
     * @param {?} count
     * @return {?}
     */
    Query.prototype.count = function (count) {
        this._count = count;
        return this;
    };
    /**
     * @param {...?} fields
     * @return {?}
     */
    Query.prototype.select = function () {
        var fields = [];
        for (var _b = 0; _b < arguments.length; _b++) {
            fields[_b] = arguments[_b];
        }
        this._select = fields;
        return this;
    };
    /**
     * @param {?} result
     * @param {?} prefix
     * @param {?} delimiter
     * @param {?} variable
     * @return {?}
     */
    Query.checkAndAppend = function (result, prefix, delimiter, variable) {
        if (variable == null)
            return result;
        if (typeof variable == "number" && variable == 0) {
            return result;
        }
        if (typeof variable == "boolean" && !variable) {
            return result;
        }
        if (variable)
            return Query.append(result, prefix, delimiter, variable);
        return result;
    };
    /**
     * @param {?} result
     * @param {?} prefix
     * @param {?} delimiter
     * @param {?} variable
     * @return {?}
     */
    Query.append = function (result, prefix, delimiter, variable) {
        var /** @type {?} */ length = result.length;
        if (length > 0)
            result = "" + result + delimiter + prefix + "=" + variable;
        else
            result = prefix + "=" + variable;
        return result;
    };
    /**
     * @return {?}
     */
    Query.prototype.compile = function () {
        var /** @type {?} */ isExpand = this._extendedPropName != null && this._extendedPropName.length > 0;
        var /** @type {?} */ resultStr = "";
        var /** @type {?} */ delimiter = isExpand ? ';' : '&';
        if (this._top != 0) {
            resultStr = Query.checkAndAppend(resultStr, '$top', delimiter, this._top);
        }
        if (this._skip != 0) {
            resultStr = Query.checkAndAppend(resultStr, '$skip', delimiter, this._skip);
        }
        resultStr = Query.checkAndAppend(resultStr, '$count', delimiter, this._count);
        if (this._filter.length > 0) {
            resultStr = Query.checkAndAppend(resultStr, '$filter', delimiter, this._filter.join(" and "));
        }
        if (this._orderBy.length > 0) {
            resultStr = Query.checkAndAppend(resultStr, '$orderby', delimiter, this._orderBy.join(','));
        }
        if (this._select.length > 0) {
            resultStr = Query.checkAndAppend(resultStr, '$select', delimiter, this._select.join(','));
        }
        if (this._expand.length > 0) {
            var /** @type {?} */ result = [];
            for (var _b = 0, _c = this._expand; _b < _c.length; _b++) {
                var item = _c[_b];
                var /** @type {?} */ compiled = item.compile();
                result.push(compiled);
            }
            if (result.length > 0) {
                resultStr = Query.checkAndAppend(resultStr, '$expand', delimiter, result.join(','));
            }
        }
        if (resultStr.length > 0 && isExpand)
            resultStr = "(" + resultStr + ")";
        if (isExpand)
            resultStr = "" + this._extendedPropName + resultStr;
        return resultStr;
    };
    return Query;
}());
window.Query = Query || {};
window.OperatorType = OperatorType || {};
window.OrderBy = OrderBy || {};
/**
 * Generated bundle index. Do not edit.
 */
export { OperatorType, OrderBy, Query };
//# sourceMappingURL=ngx-odata-v4.es5.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/ngx-odata-v4/ngx-odata-v4.es5.js
// module id = MDYC
// module chunks = 1